'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndex = getIndex;
/* * *
 * Try to get Index from Array, or Default
 * - - - - - - - - - - - - - - - - - - - -
 * @param {array}
 * @param {number}
 * @param {default} optional
 *
 * @return {any}
 * * */

function getIndex(ary, idx, def) {
  // Setting Default Params seems to make jest blow up?
  ary = ary || [];
  idx = idx || 0;
  def = def || '';

  return typeof ary[idx] === 'undefined' ? def : ary[idx];
}


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/getIndex.js
// module id = 475
// module chunks = 0